import { Button, Flex, Group, Paper, Text } from "@mantine/core";
import { IconFileInvoice, IconX } from "@tabler/icons-react";
import { DebtResponseType } from "constants/types/debt";
import { FC, useMemo } from "react";
import { formatCurrency } from "utils/helpers/format";

interface DebtSelectionBarProps {
  selectedDebts: DebtResponseType[];
  onClear: () => void;
  onOpenBulkModal: () => void;
}

const DebtSelectionBar: FC<DebtSelectionBarProps> = ({
  selectedDebts,
  onClear,
  onOpenBulkModal,
}) => {
  const totalRemaining = useMemo(
    () =>
      selectedDebts.reduce(
        (sum, debt) => sum + (debt.totalAmount - debt.paidAmount),
        0,
      ),
    [selectedDebts],
  );

  if (selectedDebts.length === 0) return null;

  return (
    <Paper withBorder p="xs" radius="md" bg="blue.0">
      <Flex justify="space-between" align="center" gap="sm" wrap="wrap">
        <Group gap="xs">
          <Text size="sm" fw={600}>
            Đã chọn {selectedDebts.length} công nợ
          </Text>
          <Text size="sm" c="dimmed">
            | Tổng còn lại:
          </Text>
          <Text size="sm" fw={700} c="red">
            {formatCurrency(totalRemaining)}
          </Text>
        </Group>

        <Group gap="xs">
          <Button
            variant="default"
            size="xs"
            leftSection={<IconX size={14} />}
            onClick={onClear}
          >
            Xóa lựa chọn
          </Button>
          <Button
            color="green"
            size="xs"
            leftSection={<IconFileInvoice size={14} />}
            onClick={onOpenBulkModal}
          >
            Tạo nhiều phiếu thu
          </Button>
        </Group>
      </Flex>
    </Paper>
  );
};

export default DebtSelectionBar;
